export default {
    /**
     * Sets episodes.
     *
     * @param {object}    state     Vuex state.
     * @param {object[]}  episodes  List of episodes.
     */
    setEpisodes(state, episodes) {
        state.episodes = episodes;
    },

    /**
     * Sets episodes count.
     *
     * @param {object} state         Vuex state
     * @param {object} episodesCount Episodes count.
     */
    setEpisodesCount(state, episodesCount) {
        state.episodesCount = episodesCount;
    },

    /**
     * Sets total pages.
     *
     * @param {object} state      Vuex state.
     * @param {number} totalPages Amount of total pages.
     */
    setTotalPages(state, totalPages) {
        state.totalPages = totalPages;
    },
};
